import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class ClipboardService {
  constructor() {}

  copyToClipboard(value: string) {
    const handler = function(e: ClipboardEvent) {
      e.clipboardData.setData("text/plain", value);
      e.preventDefault();
    };

    document.addEventListener("copy", handler, false);
    document.execCommand("copy");
    document.removeEventListener("copy", handler, false);
  }
}
